export default {
  createNewAccount: 'create new account',
  login: 'log in',
  appStore: 'go to app store',
  useMobile: 'use mobile number',
  requestNewCode: 'request new code',
};
